import { Outlet, useParams } from 'react-router-dom'
import { Stack, Grid2 as Grid } from '@mui/material'
import { SPACING } from '@common/theme/spacing'
import { useQCTask } from '@features/qc_task_details_view/hooks/useQCTask'
import { BreadcrumbItem } from '@common/components/Breadcrumb'
import { RouteKeyEnum } from 'src/routes'
import QCDetailsTabs from './QCDetailsTabs'
import QCDetailsHeader from './QCDetailsHeader'
import { CombinedPermissionsProvider } from '@auth/hooks/useCombinedPermissions'
import { BaseLayout } from '@common/components/layouts/BaseLayout'
import { useGetStudyById } from '@study_setup/hooks/useStudyQueries'
import { SIZING } from '@common/theme/sizing'
import { useGetQcTaskSubmissionMetadata } from '@features/qc_task_details_view/hooks/useGetQCTaskSubmissionQueries'

export default function QCDetailsLayout() {
  const { studyId, qcTaskId } = useParams()

  const { data: qcTaskData, error: qcTaskError, isLoading: isQcTaskLoading } = useQCTask(['QCTask'], studyId, qcTaskId)
  const { data: studyData, isLoading: isStudyLoading } = useGetStudyById(studyId!)
  const { data: metadata, isLoading: isMetadataLoading } = useGetQcTaskSubmissionMetadata({
    study_id: studyId!,
    qc_task_id: qcTaskId!,
  })

  const renderBreadCrumbs = (): BreadcrumbItem[] => {
    return [
      {
        title: 'Home',
        route_key: RouteKeyEnum.HOME,
      },
      {
        title: studyData ? `${studyData.nickname} (${studyData.user_facing_study_id})` : '',
        route_key: RouteKeyEnum.STUDY_DETAILS,
        params: { studyId: studyId! },
      },
      {
        title: `QC Tasks`,
        route_key: RouteKeyEnum.QC_TASKS,
        params: { studyId: studyId! },
      },
    ]
  }

  if (isQcTaskLoading || isStudyLoading || isMetadataLoading) {
    return <div>Loading...</div>
  }

  if (qcTaskError || !qcTaskData || !qcTaskData.data || !metadata) {
    return <div>Error: {qcTaskError?.message}</div>
  }

  return (
    <CombinedPermissionsProvider studyId={studyId!}>
      <BaseLayout>
        <Grid container size={SIZING.gridSizeXxl} paddingX={SPACING.QCDetailsSpacing}>
          <Grid size={SIZING.gridSizeXxl}>
            <QCDetailsHeader breadcrumbs={renderBreadCrumbs()} qcTask={qcTaskData.data} metadata={metadata} />
            <QCDetailsTabs />
            <Stack spacing={SPACING.spacingLg} sx={{ paddingTop: SPACING.spacingLg }}>
              <Outlet />
            </Stack>
          </Grid>
        </Grid>
      </BaseLayout>
    </CombinedPermissionsProvider>
  )
}
